// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCjF8D_-UFZO3p0z1nl-fITG-TR-ng3apA",
    authDomain: "bank-app-e0fad.firebaseapp.com",
    databaseURL: "https://bank-app-e0fad.firebaseio.com",
    projectId: "bank-app-e0fad",
    storageBucket: "bank-app-e0fad.appspot.com",
    messagingSenderId: "638677391363",
    appId: "1:638677391363:web:1b1df6646df09623a25636",
    measurementId: "G-MW0N65W4Z8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
